import {
  Button,
  CircularProgress,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
interface Props {
  isPolygonFinished: boolean;
  isLoading: boolean;
  onFinishPolygon: () => void;
}
export function DrawInitialPolygonFooter(props: Props) {
  const { isPolygonFinished, isLoading, onFinishPolygon } = props;
  const { t } = useTranslation();
  return (
    <StyledPaper elevation={0}>
      <Typography>{t("label.drawYourStudyAreaToProceed")}</Typography>
      <Button
        variant="green-contained"
        onClick={onFinishPolygon}
        disabled={!isPolygonFinished || isLoading}
      >
        {isLoading && t("label.loading")}
        {isLoading && <CircularProgress size={20} />}
        {!isLoading && t("label.ready")}
      </Button>
    </StyledPaper>
  );
}
const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  .MuiButton-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
